<template>
    <div :class="[props.size ? props.size : '']">
        <input ref="inputElement" :name="name" type="text" class="form-control" />
    </div>
</template>

<script setup lang="ts">
    import { DatePicker, type DatePickerOptions } from "@/portal/formControls/DatePicker";
    import { onMounted, ref, watch } from "vue";

    const model = defineModel<Date | undefined>({ required: true });
    const props = defineProps<{
        name?: string;
        size?: string;
        options?: DatePickerOptions;
    }>();

    const inputElement = ref<HTMLInputElement>();

    let component: DatePicker | undefined = undefined;
    onMounted(() => {
        component = new DatePicker($(inputElement.value!), props.options);
        component.setValue(model.value);
        component.onChange = () => {
            if (isDateChanged()) {
                model.value = component?.getValue();
            }
        };
    });

    watch(model, (value) => {
        if (isDateChanged()) {
            component?.setValue(value);
        }
    });

    function isDateChanged() {
        return model.value?.getTime() != component?.getValue()?.getTime();
    }

    function setError(hasError: boolean) {
        component?.setError(hasError);
    }

    defineExpose({
        setError,
    });
</script>
